define('v3/Pages/Home/Services/SubjectGroup.Backend',[
	'jquery',
	'lodash',
	'BackendBase',
	'v3/Common/Services/Backend/subjectGroupBackend'
], function ($, _, BackendBase) {
	function SubjectGroupBackend () {
		BackendBase.call(this);
	};

	SubjectGroupBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(SubjectGroupBackend.prototype, {

		getAllAvailablePupils: function () {
			return this._getJsonApi('Pupils/AllAvailableForSubjectGroups');
		},
		getGroupDetailsPupilIds: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/' + subjectGroupId + '/DetailsAndPupilIds');
		},
		savePupilIdsInGroup: function (subjectGroupId, groupName, pupilIds) {
			return this._postApi('SubjectGroups/PupilIdsInGroup', { subjectGroupId: subjectGroupId, groupName: groupName, pupilIds: pupilIds });
		},
		saveGroupName: function (subjectGroupId, groupName) {
			return this._postApi('SubjectGroups/GroupName', { subjectGroupId: subjectGroupId, groupName: groupName });
		},
		getRedirectToTeachV4Url: function (subjectGroupId) {
			return this._getJsonApi('SubjectGroups/RedirectToTeachV4Url/' + subjectGroupId);
		}
	});

	return new SubjectGroupBackend();
});

